export const DASHBOARD_FULLSTATS_RESPONSE = 'DASHBOARD_FULLSTATS_RESPONSE'
export const DASHBOARD_SUBSCRIBERSLANGUAGESTATS_RESPONSE =
  'DASHBOARD_SUBSCRIBERSLANGUAGESTATS_RESPONSE'
export const DASHBOARD_SUBSCRIBERSGENDERSTATS_RESPONSE = 'DASHBOARD_SUBSCRIBERSGENDERSTATS_RESPONSE'
export const DASHBOARD_SUBSCRIBERSRECENTLIST_RESPONSE = 'DASHBOARD_SUBSCRIBERSRECENTLIST_RESPONSE'
export const DASHBOARD_FETCH_ENTITIES_COUNT_RESPONSE = 'DASHBOARD_FETCH_ENTITIES_COUNT_RESPONSE'
export const DASHBOARD_FETCH_ENTITIES_COUNT_ERROR = 'DASHBOARD_FETCH_ENTITIES_COUNT_ERROR'
export const DASHBOARD_FETCH_EARNED_LIST_RESPONSE = 'DASHBOARD_FETCH_EARNED_LIST_RESPONSE'
export const DASHBOARD_FETCH_DANGER_FLOWS_DATA = 'DASHBOARD_FETCH_DANGER_FLOWS_DATA'
export const DASHBOARD_FETCH_DANGER_FLOWS_DATA_ERROR = 'DASHBOARD_FETCH_DANGER_FLOWS_DATA_ERROR'
export const DASHBOARD_SHOW_DANGER_FLOWS_DATA = 'DASHBOARD_SHOW_DANGER_FLOWS_DATA'
export const DASHBOARD_FETCH_DANGER_FLOWS_LIST = 'DASHBOARD_FETCH_DANGER_FLOWS_LIST'

// home tab
export const GET_JOBS_QUESTIONNAIRE_ANSWERS = 'GET_JOBS_QUESTIONNAIRE_ANSWERS'
export const GET_JOBS_QUESTIONNAIRE_ANSWERS_RESPONSE = 'GET_JOBS_QUESTIONNAIRE_ANSWERS_RESPONSE'
